import { FETCH_TIMESHEET_SUCCESS } from "../Constants";

const initialAuthState = {};

export default (state = initialAuthState, action) => {
  switch (action.type) {
    case FETCH_TIMESHEET_SUCCESS:
      return {
        payload: action.data,
      };

    default:
      return state;
  }
};
